export default __webpack_public_path__ + "static/media/TER1.2e2184b9.jpg";